"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSortItemForCol = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var tableDescriptorTypes_1 = require("./tableDescriptorTypes");
var ts_invariant_1 = require("ts-invariant");
var sdk_model_1 = require("@gooddata/sdk-model");
var zip_1 = tslib_1.__importDefault(require("lodash/zip"));
function createAttributeLocator(attribute, header) {
    // if this bombs it means something is wrong with the col descriptors or in very bad case in the DVF data access logic.
    // by contract, all data series have same number of descriptors & headers. therefore the zipping logic should never
    // run into situation where the arrays are of different size.
    ts_invariant_1.invariant(attribute && header);
    return {
        attributeLocatorItem: {
            attributeIdentifier: attribute.attributeHeader.localIdentifier,
            element: header.attributeHeaderItem.uri,
        },
    };
}
function createMeasureLocator(measure) {
    return {
        measureLocatorItem: {
            measureIdentifier: measure.measureHeaderItem.localIdentifier,
        },
    };
}
/**
 * Creates a SortItem for the provided column, sorting in particular direction. Depending on the column type,
 * this factory will create either an attribute sort item or measure sort item with appropriate locators.
 *
 * Note the originalSorts. These are optional, if provided they are used when creating an attribute sort to
 * determine whether to create 'normal' or area sort for that column.
 *
 * @param col - col to get sort item for
 * @param direction - sort direction
 * @param originalSorts - original sorts, optional, to determine if area sort indicator should be transferred.
 */
function createSortItemForCol(col, direction, originalSorts) {
    if (originalSorts === void 0) { originalSorts = []; }
    if (tableDescriptorTypes_1.isSliceCol(col)) {
        var attributeLocalId_1 = col.attributeDescriptor.attributeHeader.localIdentifier;
        var matchingOriginalSortItem = originalSorts.find(function (s) { return sdk_model_1.isAttributeSort(s) && s.attributeSortItem.attributeIdentifier === attributeLocalId_1; });
        return sdk_model_1.isAttributeAreaSort(matchingOriginalSortItem)
            ? sdk_model_1.newAttributeAreaSort(attributeLocalId_1, direction)
            : sdk_model_1.newAttributeSort(attributeLocalId_1, direction);
    }
    else if (tableDescriptorTypes_1.isSeriesCol(col)) {
        var locators_1 = [];
        if (col.seriesDescriptor.attributeDescriptors && col.seriesDescriptor.attributeHeaders) {
            var descriptorAndHeaders = zip_1.default(col.seriesDescriptor.attributeDescriptors, col.seriesDescriptor.attributeHeaders);
            descriptorAndHeaders.forEach(function (_a) {
                var descriptor = _a[0], header = _a[1];
                return locators_1.push(createAttributeLocator(descriptor, header));
            });
        }
        locators_1.push(createMeasureLocator(col.seriesDescriptor.measureDescriptor));
        return {
            measureSortItem: {
                direction: direction,
                locators: locators_1,
            },
        };
    }
    throw new ts_invariant_1.InvariantError("cannot get sort item for the column type " + col.type);
}
exports.createSortItemForCol = createSortItemForCol;
//# sourceMappingURL=colSortItemFactory.js.map